export default __webpack_public_path__ + "static/media/sheepIcon.af2cb094.svg";